<template>
  <v-skeleton-loader
    v-if="isLoading"
    type="heading"
    class="topbar-page-title-loader"
    width="200"
  />
  <div v-else class="topbar-page-title">
    <h2>{{ pageTitle }}</h2>

    <slot name="post-title" />

    <InsightsTooltip
      v-if="tooltip.key"
      :tooltip="tooltip"
      full-width-activator
      tooltip-direction="end"
      :max-width="tooltipMaxWidth"
    />

    <slot name="post-tooltip" />
  </div>
</template>

<script setup>
import InsightsTooltip from '@/components/insights/InsightsTooltip.vue';

defineProps({
  pageTitle: { type: String, default: '' },
  tooltip: { type: Object, default: () => {} },
  isLoading: { type: Boolean, default: false },
  tooltipMaxWidth: { type: String, default: '240px' },
});
</script>

<style scoped lang="less">
.topbar-page-title-loader {
    margin-top: 12px;
    background: transparent;
}

:deep(.v-skeleton-loader__heading) {
  margin: 0 16px 0 0;
}

.topbar-page-title {
  display: flex;
  align-items: center;
  margin-right: 24px;

  h2 {
    font-size: 28px;
    font-weight: 700;
    white-space: nowrap;
    margin-right: 8px;
  }
}
</style>
